import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";



const SubscribersList = () => {
    const [subscribers, setSubscribers] = useState([]);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchSubscribers = async () => {
        try {
          const querySnapshot = await getDocs(collection(db, "subscribers"));
          const emails = querySnapshot.docs.map(doc => doc.data().email); // Assuming email is stored as document ID
        //   console.log(querySnapshot.docs)
          setSubscribers(emails);
          
        } catch (error) {
          console.error("Error fetching subscribers:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchSubscribers();
    }, []);
  
    return (
      <div className="max-w-md mx-auto p-4 border rounded-lg shadow-lg bg-white">
        <h2 className="text-xl font-bold mb-4">Subscribers</h2>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <p className="font-semibold">Total Subscribers: {subscribers.length}</p>
            <ul className="list-disc pl-5 mt-2">
              {subscribers.map((email, index) => (
                <li key={index} className="text-gray-700">{email}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    );
  };
  
  export default SubscribersList;